import React from 'react';
import './TestimonialCard.scss';

const TestimonialCard = ({ name, title, rating, review, image, highlighted  }) => {
  const stars = Array.from({ length: 5 }, (_, index) => (
    <span key={index} className={index < rating ? 'star filled' : 'star'}>
      ★
    </span>
  ));

  return (
    <div className={`testimonial-card ${highlighted ? 'highlighted' : ''}`}>
      <div className='profile-image-outer'>
        <div className="profile-image-container">
          <img src={image} alt={name} className="profile-image" />
        </div>
      </div>
      <div className="testimonial-content">
        <div className="rating">{stars}</div>
        <h3 className="name">{name}</h3>
        <p className="title">{title}</p>
        <p className="review">{review}</p>
      </div>
    </div>
  );
};
export default TestimonialCard;